import React, { Component } from "react";
import { withRouter } from '../../common/with-router';
import {Card} from "react-bootstrap";

class Pagina404 extends Component {
    render() {
        return (
            <div>
                <h4 className="page-title">Página não encontrada</h4>
                <Card border="light">
                    <Card.Body>                    
                        <p className="mt-3">O registro que você tentou acessar não foi encontrado</p>                 
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Pagina404);